<div *ngIf="videoUrl">
    <video muted width="100%" height="100%" autoplay="autoplay" loop playsinline="">
        <source
            src={{videoUrl}}>
        Your browser does not support the video tag.
    </video>
    <!-- <button class="close-button" (click)="closeVideo()"> &#x2715;</button> -->
</div>
